"use client"

import { useState, useEffect } from "react"

const TUTORIAL_STORAGE_KEY = "pelf-tutorial-completed"

export const useTutorial = () => {
  const [isTutorialOpen, setIsTutorialOpen] = useState(false)
  const [hasSeenTutorial, setHasSeenTutorial] = useState(true) // Default true to avoid flash

  // Check localStorage on mount
  useEffect(() => {
    const completed = localStorage.getItem(TUTORIAL_STORAGE_KEY)
    const hasCompleted = completed === "true"
    setHasSeenTutorial(hasCompleted)
  }, [])

  const openTutorial = () => {
    setIsTutorialOpen(true)
  }

  const closeTutorial = () => {
    setIsTutorialOpen(false)
    // Mark as completed when closed
    localStorage.setItem(TUTORIAL_STORAGE_KEY, "true")
    setHasSeenTutorial(true)
  }

  return {
    isTutorialOpen,
    hasSeenTutorial,
    openTutorial,
    closeTutorial,
  }
}
